module.exports = __webpack_public_path__ + "img/NextStep.4e76f42a.svg";